"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Confirm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const buttons_1 = require("../../atoms/buttons");
const Base_1 = require("./Base");
const Confirm = ({ translations, onCloseModal, onConfirm, children }) => {
    const onContentClick = (e) => e.stopPropagation();
    return ((0, jsx_runtime_1.jsx)(Base_1.ModalBase, { onCloseModal: onCloseModal, children: (0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsxs)(Content, { onClick: onContentClick, children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: translations.title }, void 0), (0, jsx_runtime_1.jsxs)(Body, { children: [children, (0, jsx_runtime_1.jsxs)(Buttons, { children: [(0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "secondary", onClick: onCloseModal, children: translations.cancel }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", onClick: onConfirm, children: translations.confirm }, void 0)] }, void 0)] }, void 0)] }, void 0) }, void 0) }, void 0));
};
exports.Confirm = Confirm;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;
const Content = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  width: 387px;

  & > h4 {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
    font-weight: 600;
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};
  }
`;
const Body = styled_components_1.default.div `
  padding: ${({ theme }) => theme.spacings.xl};
`;
const Buttons = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 11px;
  padding-top: ${({ theme }) => theme.spacings.m};
`;
//# sourceMappingURL=Confirm.js.map